var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header-class":"bar-color2","no-body":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('timeline-header',{attrs:{"date":_vm.data.date,"time":_vm.data.date,"title":_vm.data.title}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }